import * as Yup from 'yup';

export const ExecuteNDARequest = Yup.object().shape({
    userId: Yup.string().required('f:validation.required'),
});
